import { createSlice } from '@reduxjs/toolkit';
import { fetchPersonSources } from './personSourceThunks';
import type { PersonSourceState } from './personSourceTypes';

const initialState: PersonSourceState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  totalCount: 0,
};

/**
 * Slice read-only: niente create/update/remove (backend non li espone).
 * `byId` viene popolato solo da fetchPersonSources.fulfilled — i consumer
 * che vogliono caching cross-view possono dispatchare il thunk una volta
 * e leggere da state.personSources.byId.
 */
export const personSourceSlice = createSlice({
  name: 'personSources',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPersonSources.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPersonSources.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        for (const item of action.payload.items) state.byId[item.personSourceId] = item;
      })
      .addCase(fetchPersonSources.rejected, (state, action) => {
        state.status = 'failed';
        state.error = (action.payload as string) ?? null;
      });
  },
});

export const personSourceReducer = personSourceSlice.reducer;
